import type { Money } from '@dastarhan/contracts';

/** Тиыны → строка «12 500 ₸». Неразрывные пробелы заменяем обычными:
 *  на чеках и в вёрстке они ведут себя предсказуемее. */
export function formatMoney(v: Money): string {
  return `${Math.trunc(v / 100).toLocaleString('ru-RU').replace(/\u00A0/g, ' ')} ₸`;
}
